module.exports = __webpack_public_path__ + "fonts/font.e62fa400.woff2";